import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = BASE ? `${BASE}/api` : null;

const TOKEN_KEY = "al_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const http = axios.create({ baseURL: API || "", withCredentials: true });
http.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

export async function fetchPosts(kind) {
  if (!API) return [];
  try {
    const res = await http.get("/posts", { params: kind ? { kind } : {} });
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
}
